module.exports = __webpack_public_path__ + "static/media/signal-2.093897fc.svg";